export default __webpack_public_path__ + "1c6bb668588be940e0829e8c6ff9c924.png";